<div class="card p-0" (click)="pushToShowProduct(product._id)">
<img [src]="product.imgUrl" class="card-img-top" alt="Imagen no disponible">
<div class="container">
    <b *ngIf="product.talles.length > 4" class="talles">+</b>
    <b *ngFor="let talle of product.talles.slice(0,3)" class="talles">{{talle}}</b>
</div>
<div class="card-body">
    <h4 class="card-title">
        <span *ngIf="isNew(product)" class="badge bg-danger">New🔥</span>
        <div *ngIf="product.discount" >
            <span class="card-title">${{getPrice}}</span>
            <h6><del class="text-discount">${{product.price}}</del></h6>
        </div>
        <h6 *ngIf="!product.discount" class="card-title">${{product.price}}</h6>
    </h4>
    <div class="text-muted ">
    {{product.name}}
    </div>
    <div class="card-description"> 
        {{product.description | truncate : 50}}
    </div>
</div>
</div>